import { Text, TextField } from "@radix-ui/themes";
import clsx from "clsx";
import Stack from "./stack";

type InputProps = React.ComponentProps<typeof TextField.Root> & {
  IconLeft?: React.ReactNode;
  className?: string;
  title?: string;
  titleColor?: string;
  textInputColor?: string;
  placeholder?: string;
  placeholderColor?: string;
  autoFillTextColor?: string;
  width?: string;
  height?: string;
};

export default function Input({
  width,
  height,
  IconLeft,
  className,
  title,
  titleColor = "#344054",
  textInputColor = "#FFFFFF",
  placeholder,
  ...props
}: InputProps) {
  return (
    <Stack
      gap={"6px"}
      height={height}
      width={width}
      className={clsx(width ? "" : "w-full")}
    >
      {title && (
        <Text
          className={clsx("text-[14px] font-normal")}
          style={{
            color: titleColor,
          }}
        >
          {title}
        </Text>
      )}
      <TextField.Root
        {...props}
        placeholder={placeholder}
        style={{
          color: textInputColor,
        }}
        className={clsx(
          "!w-full !h-[40px] !rounded-[8px]  !text-[14px] !font-light  !bg-transparent !justify-center !items-center",
          className
        )}
        title=""
      >
        {IconLeft && <TextField.Slot>{IconLeft}</TextField.Slot>}
      </TextField.Root>
    </Stack>
  );
}
